import { render, staticRenderFns } from "./system-log.vue?vue&type=template&id=1977a57c"
import script from "./system-log.vue?vue&type=script&lang=ts"
export * from "./system-log.vue?vue&type=script&lang=ts"
import style0 from "./system-log.vue?vue&type=style&index=0&id=1977a57c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports